export const JSON_TYPE = 'application/json';
export const XML_TYPE = 'application/xml';
export const HTML_TYPE = 'text/html';
export const CSV_TYPE = 'text/csv';
export const FILE_TYPE = 'multipart/form-data';
